var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "page page-gradeQueryResult",
    },
    [
      _c(
        "div",
        { staticClass: "gradeQueryResult-search" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { float: "left" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: `${_vm.$t("examListCom.SCT")}`, name: "first" },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: `${_vm.$t("examListCom.DDP")}`,
                  name: "second",
                },
              }),
              _c("el-tab-pane", {
                attrs: { label: `${_vm.$t("examListCom.TKT")}`, name: "third" },
              }),
            ],
            1
          ),
          _c("span", { staticStyle: { float: "right", color: "#9498A3" } }, [
            _vm._v(" " + _vm._s(_vm.$t("examListCom.G"))),
            _c(
              "strong",
              { staticStyle: { color: "#5397F7", margin: "0 5px" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.activeName === "second"
                      ? _vm.theoryListLen
                      : _vm.activeName == "third"
                      ? _vm.thirdListLen
                      : _vm.list.length
                  )
                ),
              ]
            ),
            _vm._v(_vm._s(_vm.$t("examListCom.TJG")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "gradeQueryResult_main",
          staticClass: "gradeQueryResult-main",
          class: _vm.tabName == "dxxl" ? "gradeQueryResult-main-noExam" : "",
          attrs: { id: "page" },
        },
        [
          _vm.list.length && _vm.activeName === "first"
            ? _c(
                "div",
                _vm._l(_vm.list, function (item, item_index) {
                  return _c("div", { key: item_index }, [
                    _c(
                      "div",
                      {
                        ref: "page" + item_index,
                        refInFor: true,
                        staticClass: "questionInfo single_question",
                        class: { questionMask: !item.isShowMore },
                        attrs: { id: "page" + item_index },
                      },
                      [
                        _c("p", { staticClass: "flex_header" }, [
                          _c("span", [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(item.questionNum) + "、"),
                            ]),
                            _c("span", { staticStyle: { margin: "0 10px" } }, [
                              _vm._v(_vm._s(_vm.$t("examListCom.ZF")) + "："),
                              _c(
                                "strong",
                                {
                                  staticStyle: {
                                    color: "red",
                                    margin: "0 5px",
                                  },
                                },
                                [_vm._v(_vm._s(item.fullScore))]
                              ),
                              _vm._v("分"),
                            ]),
                            _c("span", { staticStyle: { margin: "0 10px" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("examListCom.DSCORE")) + "： "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.blankStatus === 1,
                                      expression: "item.blankStatus === 1",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "strong",
                                    {
                                      staticStyle: {
                                        color: "#5397F7",
                                        margin: "0 5px",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.questionResult || "-"))]
                                  ),
                                  _vm._v(
                                    _vm._s(_vm.$t("examListCom.SCORE")) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.blankStatus === 0 ||
                                        item.blankStatus === undefined,
                                      expression:
                                        "item.blankStatus === 0 || item.blankStatus === undefined",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "strong",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        margin: "0 5px",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("examListCom.WZD")))]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c(
                            "span",
                            { staticClass: "child" },
                            [
                              _vm.routeData.answerFlag !== 0
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: [
                                            ["teacher", "admin", "student"],
                                            "pro",
                                          ],
                                          expression:
                                            "[['teacher', 'admin', 'student'], 'pro']",
                                        },
                                      ],
                                      attrs: {
                                        type: "primary",
                                        plain: "",
                                        size: "mini",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goInto(item, item_index)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("examListCom.CKPF")))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("el-divider"),
                        _c(
                          "p",
                          { staticClass: "question_title" },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !item.isShowMore,
                                    expression: "!item.isShowMore",
                                  },
                                ],
                                attrs: { type: "info", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeIsShowMore(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("examListCom.Zk")) + " "
                                ),
                                _c("i", {
                                  staticClass: "el-icon-caret-bottom",
                                }),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.isShowMore,
                                    expression: "item.isShowMore",
                                  },
                                ],
                                attrs: { type: "info", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeIsShowMore(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("examListCom.SQ")) + " "
                                ),
                                _c("i", { staticClass: "el-icon-caret-top" }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", {
                          staticClass: "div_content",
                          domProps: { innerHTML: _vm._s(item.questionContent) },
                        }),
                      ],
                      1
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
          !_vm.list.length && _vm.activeName === "first"
            ? _c("div", { staticClass: "noDatas" }, [
                _c("img", {
                  attrs: { src: require("../../../assets/zanwu.png") },
                }),
                _c("p", [_vm._v(_vm._s(_vm.$t("examListCom.ZWSJ")))]),
              ])
            : _vm._e(),
          _vm.theoryList.length && _vm.activeName === "second"
            ? _c(
                "div",
                {
                  ref: "content",
                  staticClass: "section",
                  on: { scroll: _vm.handleScroll },
                },
                [
                  _c("div", { staticClass: "test" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.theoryList, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "test-item",
                            attrs: { id: ["page" + index] },
                          },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.chnNumCharStr(index)) +
                                  " 、" +
                                  _vm._s(item.sectionName) +
                                  " "
                              ),
                              _c("span", [
                                _vm._v(
                                  "（" + _vm._s(item.sectionPrompt) + "）"
                                ),
                              ]),
                            ]),
                            _c(
                              "ul",
                              _vm._l(item.questions, function (v, i) {
                                return _c(
                                  "li",
                                  { key: i, staticClass: "test_small" },
                                  [
                                    v.internalTypeId !== 6
                                      ? _c("div", [
                                          v.internalTypeId === 9 ||
                                          v.internalTypeId === 10
                                            ? _c(
                                                "span",
                                                { staticClass: "text_index1" },
                                                [
                                                  _vm._v(
                                                    _vm._s(v.questionNum) +
                                                      ".（" +
                                                      _vm._s(v.score) +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "examListCom.SCORE"
                                                        )
                                                      ) +
                                                      "）"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          v.internalTypeId !== 9 &&
                                          v.internalTypeId !== 10
                                            ? _c(
                                                "span",
                                                { staticClass: "text_index" },
                                                [
                                                  _vm._v(
                                                    _vm._s(v.questionNum) +
                                                      ".（" +
                                                      _vm._s(v.score) +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "examListCom.SCORE"
                                                        )
                                                      ) +
                                                      "）"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          v.internalTypeId === 9 ||
                                          v.internalTypeId === 10
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "test_small_title1",
                                                },
                                                [
                                                  _c("p", {
                                                    staticClass: "text",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        v.questionContent
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          v.internalTypeId !== 9 &&
                                          v.internalTypeId !== 10
                                            ? _c("div", {
                                                staticClass:
                                                  "test_small_title ql-editor",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    v.questionContent
                                                  ),
                                                },
                                              })
                                            : _vm._e(),
                                          v.internalTypeId === 1
                                            ? _c(
                                                "ul",
                                                { staticClass: "answer" },
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      model: {
                                                        value: v.questionAnswer,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            v,
                                                            "questionAnswer",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "v.questionAnswer",
                                                      },
                                                    },
                                                    _vm._l(
                                                      v.items,
                                                      function (k, j) {
                                                        return _c(
                                                          "li",
                                                          { key: j },
                                                          [
                                                            _c(
                                                              "el-radio",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    k.itemKey,
                                                                  disabled:
                                                                    v.questionAnswer ==
                                                                    k.itemKey
                                                                      ? false
                                                                      : true,
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      k.itemKey
                                                                    ) + "："
                                                                  ),
                                                                ]),
                                                                _c("div", {
                                                                  staticClass:
                                                                    "radio_item ql-editor",
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        k.itemValue
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          v.internalTypeId === 2
                                            ? _c(
                                                "ul",
                                                { staticClass: "answer" },
                                                [
                                                  _c(
                                                    "el-checkbox-group",
                                                    {
                                                      model: {
                                                        value:
                                                          v.questionAnswerArr,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            v,
                                                            "questionAnswerArr",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "v.questionAnswerArr",
                                                      },
                                                    },
                                                    _vm._l(
                                                      v.items,
                                                      function (k, j) {
                                                        return _c(
                                                          "li",
                                                          { key: j },
                                                          [
                                                            _c(
                                                              "el-checkbox",
                                                              {
                                                                attrs: {
                                                                  disabled: (
                                                                    v.questionAnswer
                                                                      ? v.questionAnswer.includes(
                                                                          k.itemKey
                                                                        )
                                                                      : false
                                                                  )
                                                                    ? false
                                                                    : true,
                                                                  label:
                                                                    k.itemKey,
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      k.itemKey
                                                                    ) + "："
                                                                  ),
                                                                ]),
                                                                _c("p", {
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        k.itemValue
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          v.internalTypeId === 3
                                            ? _c(
                                                "ul",
                                                { staticClass: "answer" },
                                                [
                                                  _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: `${_vm.$t(
                                                              "examListCom.CORRECT"
                                                            )}`,
                                                            disabled:
                                                              v.questionAnswer ==
                                                              _vm.$t(
                                                                "examListCom.CW"
                                                              )
                                                                ? true
                                                                : false,
                                                          },
                                                          model: {
                                                            value:
                                                              v.questionAnswer,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                v,
                                                                "questionAnswer",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "v.questionAnswer",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "examListCom.CORRECT"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label:
                                                              _vm.$t(
                                                                "examListCom.CW"
                                                              ),
                                                            disabled:
                                                              v.questionAnswer ==
                                                              _vm.$t(
                                                                "examListCom.CORRECT"
                                                              )
                                                                ? true
                                                                : false,
                                                          },
                                                          model: {
                                                            value:
                                                              v.questionAnswer,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                v,
                                                                "questionAnswer",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "v.questionAnswer",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "examListCom.CW"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          v.internalTypeId === 1 ||
                                          v.internalTypeId === 2 ||
                                          v.internalTypeId === 3
                                            ? _c("p", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("examListCom.XSZD")
                                                    ) +
                                                    "： "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(v.studentAnswers)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "examListCom.CORRECANSWER"
                                                      )
                                                    ) +
                                                    ": "
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(v.studentAnswer)
                                                  ),
                                                ]),
                                              ])
                                            : _vm._e(),
                                          v.internalTypeId === 4
                                            ? _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "examListCom.CORRECANSWER"
                                                      )
                                                    ) +
                                                    "： "
                                                ),
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    v.newQuestionAnswer,
                                                    function (val, i, index) {
                                                      return _c(
                                                        "li",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                index + 1
                                                              ) +
                                                              "："
                                                          ),
                                                          _vm._l(
                                                            val,
                                                            function (
                                                              answerVal,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                { key: index },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      answerVal
                                                                    )
                                                                  ),
                                                                  val.length >
                                                                    1 &&
                                                                  index + 1 <
                                                                    val.length
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "、"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ])
                                            : _vm._e(),
                                          v.internalTypeId === 5
                                            ? _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "examListCom.CORRECANSWER"
                                                      )
                                                    ) +
                                                    "： "
                                                ),
                                                _c("p", {
                                                  staticClass: "ql-editor",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      v.questionAnswer
                                                    ),
                                                  },
                                                }),
                                              ])
                                            : _vm._e(),
                                          !v.flag &&
                                          v.internalTypeId !== 9 &&
                                          v.internalTypeId !== 10
                                            ? _c("span", {
                                                staticClass: "analysis_cont",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    v.questionAnalysis
                                                      ? v.questionAnalysis
                                                      : _vm.$t(
                                                          "examListCom.ZWJX"
                                                        )
                                                  ),
                                                },
                                              })
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                    v.internalTypeId === 6
                                      ? _c(
                                          "div",
                                          { staticClass: "combination" },
                                          [
                                            v.internalTypeId === 9 ||
                                            v.internalTypeId === 10
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "test_small_title1",
                                                  },
                                                  [
                                                    _c("p", {
                                                      staticClass:
                                                        "text ql-editor",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          v.questionContent
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      v.childQuestions.length -
                                                        1 !=
                                                      0,
                                                    expression:
                                                      "v.childQuestions.length - 1 != 0",
                                                  },
                                                ],
                                                staticClass: "question_index",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "examListCom.YDYXNR"
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(v.questionNum) +
                                                    " - " +
                                                    _vm._s(
                                                      v.questionNum +
                                                        v.childQuestions
                                                          .length -
                                                        1
                                                    ) +
                                                    _vm._s(
                                                      _vm.$t("examListCom.TI")
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      v.childQuestions.length -
                                                        1 ==
                                                      0,
                                                    expression:
                                                      "v.childQuestions.length - 1 == 0",
                                                  },
                                                ],
                                                staticClass: "question_index",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "examListCom.YDYXNR"
                                                      )
                                                    ) +
                                                    _vm._s(v.questionNum) +
                                                    _vm._s(
                                                      _vm.$t("examListCom.TI")
                                                    )
                                                ),
                                              ]
                                            ),
                                            v.internalTypeId !== 9 &&
                                            v.internalTypeId !== 10
                                              ? _c("div", {
                                                  staticClass:
                                                    "test_small_title",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      v.questionContent
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._l(
                                              v.childQuestions,
                                              function (single, m) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: m,
                                                    staticClass:
                                                      "groupQuestion",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "question_content",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              single.questionNum -
                                                                1
                                                            ) +
                                                              ". " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.ZF"
                                                                )
                                                              ) +
                                                              ":（" +
                                                              _vm._s(
                                                                single.score
                                                              ) +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.SCORE"
                                                                )
                                                              ) +
                                                              "）" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.DSCORE"
                                                                )
                                                              ) +
                                                              ": (" +
                                                              _vm._s(
                                                                single.allScore ==
                                                                  0
                                                                  ? 0
                                                                  : single.allScore
                                                                  ? single.allScore
                                                                  : "-"
                                                              ) +
                                                              ") " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.SCORE"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]),
                                                        single.internalTypeId ==
                                                          1 ||
                                                        single.internalTypeId ===
                                                          2 ||
                                                        single.internalTypeId ==
                                                          3
                                                          ? _c("p", {
                                                              staticClass:
                                                                "text ql-editor",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    single.questionContent
                                                                  ),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    single.internalTypeId === 1
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "answer",
                                                          },
                                                          [
                                                            _c(
                                                              "el-radio-group",
                                                              {
                                                                model: {
                                                                  value:
                                                                    single.questionAnswer,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        single,
                                                                        "questionAnswer",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "single.questionAnswer",
                                                                },
                                                              },
                                                              _vm._l(
                                                                single.items,
                                                                function (
                                                                  k,
                                                                  j
                                                                ) {
                                                                  return _c(
                                                                    "li",
                                                                    { key: j },
                                                                    [
                                                                      _c(
                                                                        "el-radio",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                k.itemKey,
                                                                              disabled:
                                                                                single.questionAnswer ==
                                                                                k.itemKey
                                                                                  ? false
                                                                                  : true,
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  k.itemKey
                                                                                ) +
                                                                                  "："
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "radio_item ql-editor",
                                                                              domProps:
                                                                                {
                                                                                  innerHTML:
                                                                                    _vm._s(
                                                                                      k.itemValue
                                                                                    ),
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    single.internalTypeId === 2
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "answer",
                                                          },
                                                          [
                                                            _c(
                                                              "el-checkbox-group",
                                                              {
                                                                model: {
                                                                  value:
                                                                    single.questionAnswerArr,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        single,
                                                                        "questionAnswerArr",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "single.questionAnswerArr",
                                                                },
                                                              },
                                                              _vm._l(
                                                                single.items,
                                                                function (
                                                                  k,
                                                                  j
                                                                ) {
                                                                  return _c(
                                                                    "li",
                                                                    { key: j },
                                                                    [
                                                                      _c(
                                                                        "el-checkbox",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              disabled: true,
                                                                              label:
                                                                                k.itemKey,
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  k.itemKey
                                                                                ) +
                                                                                  "："
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "ql-editor",
                                                                              domProps:
                                                                                {
                                                                                  innerHTML:
                                                                                    _vm._s(
                                                                                      k.itemValue
                                                                                    ),
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    single.internalTypeId === 3
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "answer",
                                                          },
                                                          [
                                                            _c(
                                                              "li",
                                                              [
                                                                _c(
                                                                  "el-radio",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "examListCom.CORRECT"
                                                                        ),
                                                                      disabled:
                                                                        single.questionAnswer ==
                                                                        _vm.$t(
                                                                          "examListCom.CW"
                                                                        )
                                                                          ? true
                                                                          : false,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        single.questionAnswer,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            single,
                                                                            "questionAnswer",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "single.questionAnswer",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "examListCom.CORRECT"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "li",
                                                              [
                                                                _c(
                                                                  "el-radio",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "examListCom.CW"
                                                                        ),
                                                                      disabled:
                                                                        single.questionAnswer ==
                                                                        _vm.$t(
                                                                          "examListCom.CORRECT"
                                                                        )
                                                                          ? true
                                                                          : false,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        single.questionAnswer,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            single,
                                                                            "questionAnswer",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "single.questionAnswer",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "examListCom.CW"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    single.internalTypeId ===
                                                      1 ||
                                                    single.internalTypeId ===
                                                      2 ||
                                                    single.internalTypeId === 3
                                                      ? _c("p", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.CORRECANSWER"
                                                                )
                                                              ) +
                                                              "： "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "20px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  single.questionAnswer
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.XSDA"
                                                                )
                                                              ) +
                                                              "： "
                                                          ),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                single.answer ==
                                                                  "false" ||
                                                                  !single.answer
                                                                  ? "-"
                                                                  : single.answer
                                                              )
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                    single.internalTypeId === 4
                                                      ? _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.CORRECANSWER"
                                                                )
                                                              ) +
                                                              "： "
                                                          ),
                                                          _c(
                                                            "ul",
                                                            _vm._l(
                                                              single.newQuestionAnswer,
                                                              function (
                                                                val,
                                                                i,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "li",
                                                                  {
                                                                    key: index,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          index +
                                                                            1
                                                                        ) +
                                                                        "："
                                                                    ),
                                                                    _vm._l(
                                                                      val,
                                                                      function (
                                                                        answerVal,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          {
                                                                            key: index,
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                answerVal
                                                                              )
                                                                            ),
                                                                            val.length >
                                                                              1 &&
                                                                            index +
                                                                              1 <
                                                                              val.length
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "、"
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                  ],
                                                                  2
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    single.internalTypeId === 5
                                                      ? _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "examListCom.CORRECANSWER"
                                                                )
                                                              ) +
                                                              "： "
                                                          ),
                                                          _c("p", {
                                                            staticClass:
                                                              "ql-editor",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                single.questionAnswer
                                                              ),
                                                            },
                                                          }),
                                                        ])
                                                      : _vm._e(),
                                                    !single.flag &&
                                                    (single.internalTypeId ===
                                                      9 ||
                                                      single.internalTypeId ===
                                                        10)
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "commentCont",
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "comment1",
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "comment2",
                                                              },
                                                              [
                                                                _c(
                                                                  "my-component",
                                                                  {
                                                                    attrs: {
                                                                      isShow:
                                                                        "",
                                                                      optObject:
                                                                        _vm.optObject,
                                                                      refresh:
                                                                        _vm.refresh,
                                                                      myId: single.questionId,
                                                                      type: _vm.type,
                                                                      labelId:
                                                                        _vm.labelId,
                                                                      preview:
                                                                        "",
                                                                      companyCode:
                                                                        _vm.companyCode,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c("div", {
                                                              staticClass:
                                                                "comment3",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    v.internalTypeId === 6 &&
                                    item.questions.length > 1
                                      ? _c("div", { staticClass: "line" })
                                      : _vm._e(),
                                    _c("div", {
                                      staticStyle: { clear: "both" },
                                    }),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          !_vm.theoryList.length && _vm.activeName === "second"
            ? _c("div", { staticClass: "noDatas" }, [
                _c("img", {
                  attrs: { src: require("../../../assets/zanwu.png") },
                }),
                _c("p", [_vm._v(_vm._s(_vm.$t("examListCom.ZWSJ")))]),
              ])
            : _vm._e(),
          _vm.thirdList.length && _vm.activeName === "third"
            ? _c("div", { staticClass: "thirdDiv" }, [
                _c("div", { staticClass: "test" }, [
                  _c(
                    "ul",
                    _vm._l(_vm.thirdList, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "test-item",
                          attrs: { id: ["page" + index] },
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.chnNumCharStr(index)) +
                                " 、" +
                                _vm._s(item.sectionName) +
                                " "
                            ),
                            _c("span", [
                              _vm._v("（" + _vm._s(item.sectionPrompt) + "）"),
                            ]),
                          ]),
                          _c(
                            "ul",
                            _vm._l(item.questions, function (v, i) {
                              return _c(
                                "li",
                                { key: i, staticClass: "test_small" },
                                [
                                  v.internalTypeId != 6
                                    ? _c("div", [
                                        v.internalTypeId !== 9 &&
                                        v.internalTypeId !== 10
                                          ? _c(
                                              "span",
                                              { staticClass: "text_index" },
                                              [
                                                _vm._v(
                                                  _vm._s(v.questionNum) +
                                                    ".（" +
                                                    _vm._s(v.score) +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "examListCom.SCORE"
                                                      )
                                                    ) +
                                                    "）"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        v.internalTypeId !== 9 &&
                                        v.internalTypeId !== 10
                                          ? _c("div", {
                                              staticClass:
                                                "test_small_title ql-editor",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  v.questionContent
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                        v.internalTypeId === 4
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "internalTypeBox",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "internalTypeLeft",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "xsda" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "examListCom.XSDA"
                                                            )
                                                          ) + "："
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "ul",
                                                      { staticClass: "ulBox" },
                                                      _vm._l(
                                                        v.studentQuestionAnswer,
                                                        function (
                                                          val,
                                                          i,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: index,
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    index + 1
                                                                  ) + "："
                                                                ),
                                                              ]),
                                                              _c(
                                                                "div",
                                                                _vm._l(
                                                                  val,
                                                                  function (
                                                                    answerVal,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: index,
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#5397f7",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            answerVal
                                                                          )
                                                                        ),
                                                                        val.length >
                                                                          1 &&
                                                                        index +
                                                                          1 <
                                                                          val.length
                                                                          ? _c(
                                                                              "span"
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "internalTypeRight",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "xsda" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "examListCom.CORRECANSWER"
                                                            )
                                                          ) + "："
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "ul",
                                                      { staticClass: "ulBox" },
                                                      _vm._l(
                                                        v.newQuestionAnswer,
                                                        function (
                                                          val,
                                                          i,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: index,
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    index + 1
                                                                  ) + "："
                                                                ),
                                                              ]),
                                                              _c(
                                                                "div",
                                                                _vm._l(
                                                                  val,
                                                                  function (
                                                                    answerVal,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: index,
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#5397f7",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            answerVal
                                                                          )
                                                                        ),
                                                                        val.length >
                                                                          1 &&
                                                                        index +
                                                                          1 <
                                                                          val.length
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "、"
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                  _c("div", { staticStyle: { clear: "both" } }),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.thirdList.length && _vm.activeName === "third"
            ? _c("div", { staticClass: "noDatas" }, [
                _c("img", {
                  attrs: { src: require("../../../assets/zanwu.png") },
                }),
                _c("p", [_vm._v(_vm._s(_vm.$t("examListCom.ZWSJ")))]),
              ])
            : _vm._e(),
        ]
      ),
      _c("scoreDetail", { ref: "scoreDetail" }),
      _vm.tabName == "dxxl"
        ? _c("paginator", {
            staticStyle: { padding: "8px" },
            attrs: {
              pageSize: _vm.pageSize,
              pageNum: _vm.pageNum,
              total: _vm.total,
              "current-page": _vm.pageNum,
            },
            on: {
              handleCurrentChange: _vm.currentPageFn,
              handleSizeChange: _vm.sizeChangeFn,
              "update:currentPage": function ($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function ($event) {
                _vm.pageNum = $event
              },
              "current-change": function ($event) {
                return _vm.searchBtn(_vm.pageNum)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }